import React, { Component } from 'react'

import './styles/Modal.css'

import XButton from '../../../assets/X Circle.svg'
import PlayIcon from '../../../assets/play icon.svg'
import PauseIcon from '../../../assets/pause icon.svg'
import ForwardIcon from '../../../assets/forward icon.svg'
import BackwardIcon from '../../../assets/backward icon.svg'

import placeholderImage from '../../../assets/download.jpeg'; // FOR TESTING PURPOSES ONLY

export default class Modal extends Component {
  render() {

		let modalStatusClass = this.props.modalHidden ? 'inactive' : 'active';

		const artist = this.props.artist;

		let name = '';
		let key = '';
		let songs = [];
		let picture = null;
		let spotify = null;

		if (artist != null) {
			name = artist.name;
			key = artist.key;
			songs = artist.songs;
			picture = <img src={artist.picture} />;
				
			let spotifyEmbedLink = null;
			if (artist.spotify != '') {
				spotifyEmbedLink = '';

				let splitLink = artist.spotify.split("/");

				splitLink.splice(3, 0, "embed");

				splitLink.forEach(function (element) {
					spotifyEmbedLink += element + "/";
				});
			}

			spotify = spotifyEmbedLink;

		} else {
				name = '';
				key = '';
				songs = [];
				picture = null;
				spotify = null;
		}

		let songList = [];

		songs.forEach(element => {
			songList.push(
				<div className="item" onClick={this.props.selectSongAction.bind(this, element, name)}>{element.title}</div>
			);
		});

		let playPauseIcon = null;

		if (this.props.isMusicPlaying) {
			playPauseIcon = <img src={PauseIcon} className="asset" />;
		} else {
			playPauseIcon = <img src={PlayIcon} className="asset" />;
		}

		let songDisplayText = '';
		if (this.props.songName != null) {

			if (this.props.songName == 0) {
				songDisplayText = 'Loading...';
			} else {

				songDisplayText = 'Now Playing: ';
				songDisplayText += this.props.songName;
				songDisplayText += ' by ';

				if (this.props.songArtist != null) {
					songDisplayText += this.props.songArtist;
				} else {
					songDisplayText += 'Unknown Artist';
				}

			}
		}

		let currentView = null;
		if (this.props.isSpotifyView) { 
			currentView = <div className={`bottom-spotify-modal ${modalStatusClass}`}>

				<div className='mobile-spotify-container'>

					<div className='top-container'>
						<div className="switch-view" onClick={this.props.toggleSpotifyAction}>
							View Song List
						</div>
						<img src={XButton} className='asset' onClick={this.props.closeAction} />
					</div>

					<div className='spotify-container'>
						<iframe
							src={spotify}
							width="100%" height="100%" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
					</div>

				</div>
			</div>;
		} else {
			currentView = <div className={`bottom-modal ${modalStatusClass}`}>

				<div className='mobile-modal-container'>

					<div className='mobile-artist-container'>
						<div className='artist-image'>
							{picture}
						</div>
						<div className='artist-name'>
							{name}
						</div>
						<div className="switch-view" onClick={this.props.toggleSpotifyAction}>
							View Spotify
						</div>
					</div>

					<div className='mobile-player-container'>

						<div className="song-list">
							{songList}
						</div>

						<div className="playing-text">{songDisplayText}</div>

						<div className="timeline">
							<div className="bar">
								<div className="line">
									<div className="played-line" style={{ width: this.props.barWidth }} />
								</div>
							</div>
						</div>

						<div className="controls">
							<div className="back" onClick={this.props.backwardAction}>
								<img src={BackwardIcon} className="asset" />
							</div>
							<div className="play" onClick={this.props.playAction}>
								{playPauseIcon}
							</div>
							<div className="forward" onClick={this.props.forwardAction}>
								<img src={ForwardIcon} className="asset" />
							</div>
						</div>

					</div>

					<div className='mobile-x-container'>
						<img src={XButton} className='asset' onClick={this.props.closeAction} />
					</div>

				</div>
			</div>;
		}

    return currentView;
  }
}
